





































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import EchartsComp from "./echarts.vue";
import {reportDimension, reportRank, reportSummary} from "@/services/api";
import {dateFormat} from "@/services/common";
interface List {
  rank: number,
  item: string;
  itemBrief: string;
  value: string;
}
interface SummaryList {
  summary: number;
  tip: string;
  title: string;
}
@Component({
  components: {
    "zf-echarts": EchartsComp,
  },
})
export default class Content extends Vue {
  public gmvData: any = {};
  public ordersData: any = {};
  public customersData: any = {};
  public rankList: List[] = [];
  public summaryList: SummaryList[] = [];
  public legend: string[] = [];
  public data = {
    value1: [dateFormat('YYYY-mm-dd', new Date(Date.now() - 1000 * 60 * 60 * 24 * 30)),dateFormat('YYYY-mm-dd', new Date())],
  };
  created(): void {}
  private mounted(): void {
    this.onDateRangeChange(this.data.value1);
  }
  onDateRangeChange(e: string[] = []): void {
    if (e == null) {
      e = []
    }
    this.gmv(e)
    this.orders(e)
    // 接口太慢，暂不展示
    // this.customers(e)
    this.rank("hot_page", "purchase_data", "purchase_x", e);
    this.summary("mail", "purchase_data", "purchase_x", e);
  }
  /**
   * 表单检查
   */
  summary(
    temp: string,
    dataListStr: string,
    xListStr: string,
    e: string[] = []
  ) {
    reportSummary({
      // companyId: 1,
      dimension: temp,
      start: e[0],
      end: e[1],
    }).then((res: any) => {
      if (res.data && res.data.code === 0) {
        const {
          data: { data },
        } = res;

        this.summaryList = data;
      }
    });
  }
  rank(temp: string, dataListStr: string, xListStr: string, e: string[] = []) {
    reportRank({
      // companyId: 1,
      dimension: temp,
      start: e[0],
      end: e[1],
    }).then((res: any) => {
      if (res.data && res.data.code === 0) {
        const {
          data: { data },
        } = res;

        this.rankList = data;
      }
    });
  }
  gmv(e: string[] = []) {
    reportDimension({
      // companyId: 1,
      dimension: "gmv",
      start: e[0],
      end: e[1],
    }).then((res: any) => {
      if (res.data && res.data.code === 0) {
        this.gmvData = res.data.data
      }
    });
  }
  orders(e: string[] = []) {
    reportDimension({
      // companyId: 1,
      dimension: "orders",
      start: e[0],
      end: e[1],
    }).then((res: any) => {
      if (res.data && res.data.code === 0) {
        this.ordersData = res.data.data
      }
    });
  }
  customers(e: string[] = []) {
    reportDimension({
      // companyId: 1,
      dimension: "customers",
      start: e[0],
      end: e[1],
    }).then((res: any) => {
      if (res.data && res.data.code === 0) {
        this.customersData = res.data.data
      }
    });
  }

  /**
   * 数字格式化
   */
  format(num: number) {
    if (num >= 10000 && num < 100000000){
      return (num / 10000).toFixed(2) + (this.$t('components.home.content.text_4e07') as string);
    } else if (num >= 100000000) {
      return (num / 100000000).toFixed(2) + (this.$t('components.home.content.text_4ebf') as string);
    } else {
      return String(num);
    }
  }

  // 给数字加千位逗号分隔符
  private format2(n: number|string) {
    let num = n.toString();
    let decimals = "";
    // 判断是否有小数
    num.indexOf(".") > -1 ? (decimals = num.split(".")[1]) : decimals;
    let len = decimals? num.length - decimals.length - 1: num.length;
    if (len <= 3) {
      return num;
    } else {
      let temp = "";
      let remainder = len % 3;
      decimals ? (temp = "." + decimals) : temp;
      if (remainder > 0) {
        // 不是3的整数倍
        return (
                num.slice(0, remainder) +
                "," +
                num.slice(remainder, len).match(/\d{3}/g)?.join(",") +
                temp
        );
      } else {
        // 是3的整数倍
        return num.slice(0, len).match(/\d{3}/g)?.join(",") + temp;
      }
    }
  }

  /**
   * 禁用时间
   */
  get pickerOptions() {
    return {
      disabledDate: function(time: any) {
        return time.getTime() > Date.now();
      }
    }
  }
}
